
import Vue from 'vue'
//import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import Vuetify, { VLayout } from 'vuetify'
import IconTsInput1 from '../icons/IconTsInput1.vue'
import IconRfOut from '../icons/IconRfOut.vue'
import IconInfo from '../icons/IconInfo.vue'
import IconHdmi from '../icons/IconHdmi.vue'
import IconSysSettings from '../icons/IconSysSettings.vue'
//import { colors } from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors'

// import { library } from '@fortawesome/fontawesome-svg-core'
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// import { fas } from '@fortawesome/free-solid-svg-icons'

// Vue.component('font-awesome-icon', FontAwesomeIcon) // Register component globally
// library.add(fas) // Include needed icons.
Vue.use(Vuetify)


export default new Vuetify( 
  {  
  components: {
    VLayout
  },  
  theme:
  {   
    themes:
    { 
      light:
      {
        primary: colors.teal,
        secondary: '#FF9100',
        accent: '#FAFAFA',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'  
      }
    }
  },
  icons: 
  {
    iconfont: 'md',
    // 'dns': {
    //   component: IconIpConfig, // you can use string here if component is registered globally
    //   props: { // pass props to your component if needed
    //     name: 'dns'
    //   }      
    // }, 
    values:
    {
      region:'language',
      upgrade:'system_update_alt',
      default:'refresh',
    'home': {
      component: IconInfo, // you can use string here if component is registered globally
      props: { // pass props to your component if needed
        name: 'home'
      }      
    }, 
    'input': {
      component: IconTsInput1, // you can use string here if component is registered globally
      props: { // pass props to your component if needed
        name: 'input'
      }      
    },
    'encoder': {
      component: IconHdmi, // you can use string here if component is registered globally
      props: { // pass props to your component if needed
        name: 'encoder'
      }      
    },
    'output': {
      component: IconRfOut, // you can use string here if component is registered globally
      props: { // pass props to your component if needed
      name: 'output'
      }      
    },
    'SysSettings': {
      component: IconSysSettings, // you can use string here if component is registered globally
      props: { // pass props to your component if needed
        name: 'SysSettings'
      }      
    }  
    
  }
    
    
  }
})
//export default new Vuetify({ ... })